import * as React from 'react';
import { Box } from '../box';
import { Stack } from '../stack';
import { MotionBox } from '../motion';

export interface SidebarNavigationOpts {
    variant?: 'light' | 'dark'
    selectedIndex?: number
    itemOpts?: any
    selectedItemOpts?: any
    indicatorSize?: number
    indicatorColor?: string
    children?: any
    onChange?: (index: number) => void
}

const SidebarNavigation: React.FC<SidebarNavigationOpts> = ({
    variant = 'dark',
    selectedIndex: initialSelectedIndex = 0,
    itemOpts,
    selectedItemOpts,
    indicatorSize = 6,
    indicatorColor = 'brand.green.base',
    onChange,
    children,
    ...rest
}: SidebarNavigationOpts): React.ReactElement => {
    const [selectedIndex, setSelectedIndex] = React.useState(initialSelectedIndex);

    const colorKey = (variant === 'light') ? 'light' : 'dark';
    itemOpts = {
        color: `text.${colorKey}.tertiary`,
        font: 'heading',
        fontSize: '3xl',
        fontWeight: 'bold',
        pl: '4px',
        textDecoration: 'none',
        _hover: {
            color: `text.${colorKey}.primary`,
            textDecoration: 'none'
        },
        ...itemOpts
    };
    selectedItemOpts = {
        color: `text.${colorKey}.primary`,
        ...selectedItemOpts
    };

    const styledItems = React.Children.map(children, (child: any, index) => {
        if (child) {
            let childProps: any = { ...child.props } || {};
            childProps.my = 0;
            childProps.onClick = () => setSelectedIndex(index);

            if (index === selectedIndex) {
                childProps = { ...childProps, ...selectedItemOpts };
            }

            return React.cloneElement(child, { ...itemOpts, ...childProps });
        }
        return child;
    });

    React.useEffect(() => {
        if (onChange) {
            onChange(selectedIndex);
        }
    }, [selectedIndex]);

    return (
        <Stack spacing={3} {...rest}>
            {styledItems.map((item, index) => (
                <Box key={`item-${index}`} position="relative">
                    <Box position="absolute" top="0" bottom="0" overflow="hidden">
                        <MotionBox
                            width={(index === selectedIndex) ? `${indicatorSize}px` : 0}
                            bg={indicatorColor}
                            // variants={{
                            //     active: {
                            //         width: indicatorSize
                            //     },
                            //     inactive: {
                            //         width: 0
                            //     }
                            // }}
                            // animate={(index === selectedIndex) ? 'active' : 'inactive'}
                            // initial="inactive"
                            // transition={{
                            //     duration: 0.3,
                            //     ease: [0.77, 0.0, 0.175, 1.0]
                            // }}
                        />
                    </Box>
                    <Box ml="12px">
                        {item}
                    </Box>
                </Box>
            ))}
        </Stack>
    );
};

export default SidebarNavigation;
